<template>
<div>
  <input type="range" ref="input" :min="min" :max="max"  class="slider" :value="value" @input="onInput" :disabled="disabled"
        @change="onChange" />
  <div class="sliderticks">
    <div class="tick" v-for="(tick, index) in ticks" :key="index" :data-tick-value="tick"></div>
  </div> 
</div>
</template>

<script>
export default {
    name: "range-slider",
    props: {
        ticks: Array,
        min: Number,
        max: Number,
        disabled: Boolean,
        value: {
            type: [String, Number],
            default: ''
        }
    },
    watch: {
        value (newVal) {
            this.setValue(newVal)
        }
    },
    mounted() {
        if (this.value) {
            this.setValue(this.value)
        }
    },
    methods: {
        setValue(value) {
            this.$refs.input.value = value
            this.$emit('input', value)
        },
        onInput(e) {
            this.setValue(e.target.value)
        },
        onChange(e) {
            this.setValue(e.target.value)
            this.$emit('change', e.target.value)
        }
    }
}
</script>

<style scoped>
* {
  box-sizing: border-box;
}
.slider {
  -webkit-appearance: none;
  appearance: none;
  width: 100%;
  height: 8px;
  background: #D3D3D3;
  outline: none;
  opacity: 0.7;
  -webkit-transition: .2s;
  transition: opacity .2s;
  border-radius: 10px;
}
.slider:hover {
  opacity: 1;
}
.slider::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  width: 18px;
  height: 18px;
  background: #42bece;

  cursor: pointer;
  border-radius: 100px;
}
.slider::-moz-range-thumb {
  width: 25px;
  height: 25px;
  background: #FF0000;
  cursor: pointer;
}
.sliderticks {
  display: flex;
  justify-content: space-between;
  padding: 0 10px;
}
.sliderticks .tick {
  position: relative;
  display: flex;
  justify-content: center;
  text-align: center;
  width: 1px;
  background: #D3D3D3;
  height: 10px;
  line-height: 40px;
  margin: 0 0 20px 0;
}
.sliderticks .tick:after{
    content:attr(data-tick-value);
    position: absolute;
    width: 100px;
    margin-top: 5px;
    font-size: 9pt;
}
</style>


// WEBPACK FOOTER //
// src/components/common/range-slider.vue